/**
 * @generated SignedSource<<64feb4ed405f2be06c3b32d1570b2937>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksVelocityWallThresholdABTest$data = {
  readonly paywallTypes: ReadonlyArray<{
    readonly entityId: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "hooksVelocityWallThresholdABTest";
};
export type hooksVelocityWallThresholdABTest$key = {
  readonly " $data"?: hooksVelocityWallThresholdABTest$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksVelocityWallThresholdABTest">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksVelocityWallThresholdABTest"
};

(node as any).hash = "24f4781ebcb72939e081458116b35b95";

export default node;
